export default (domComponents, options) => {
  const cellsResizable = options.cellsResizable;

  domComponents.addType(options.componentCellHeader, {
    isComponent: el => el.tagName === 'TH',
    model: {
      defaults: {
        name: 'Header Cell',
        tagName: 'th',
        draggable: false,
        removable: false,
        resizable: cellsResizable,
        classes: [],
      }
    },
    view: {
      events: {
        dblclick: "onDblClick",
      },

      onDblClick() {
        if (this.model.get('components').length === 0) {
          this.model.components().add({ type: 'text', content: 'Text' });
        }
      },
    }
  });
};
